import React, { useEffect } from "react";

const APP_SCHEME = "yooki://payment-success";

const PaymentSuccessRedirect = () => {
  const queryString = window.location.search || "";
  const deepLinkUrl = `${APP_SCHEME}${queryString}`;

  useEffect(() => {
    const redirectTimer = window.setTimeout(() => {
      window.location.replace(deepLinkUrl);
    }, 300);

    return () => window.clearTimeout(redirectTimer);
  }, [deepLinkUrl]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(180deg, rgba(255,248,240,1) 0%, rgba(255,255,255,1) 100%)",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          backgroundColor: "#ffffff",
          borderRadius: "24px",
          padding: "32px 24px",
          boxShadow: "0 24px 60px rgba(15, 23, 42, 0.12)",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "42px", marginBottom: "12px" }}>Payment Successful</div>
        <p style={{ color: "#475569", fontSize: "16px", lineHeight: 1.6, marginBottom: "24px" }}>
          Redirecting you back to the app to continue.
        </p>
        <button
          type="button"
          onClick={() => window.location.replace(deepLinkUrl)}
          style={{
            border: "none",
            borderRadius: "999px",
            padding: "14px 24px",
            backgroundColor: "#f97316",
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Open App
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessRedirect;
